
import React from "react";
import '../style/Contact.css';

function Contact() {
  return (
    <div className="info-section">
      <h3>Contact Us</h3>
      <p>Email: OromiaBank.com</p>
      <p>Address: Addis Ababa Ethiopia</p>
    </div>
  );
}

export default Contact;


